import script from "./reset-senha.vue?vue&type=script&setup=true&lang=js"
export * from "./reset-senha.vue?vue&type=script&setup=true&lang=js"

import "./reset-senha.vue?vue&type=style&index=0&id=0b460a67&lang=css"

const __exports__ = script;

export default __exports__